import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ArrowTopRightIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path d="M5.887 2.652a.7.7 0 0 0-.748.71c0 .414.336.768.75.79l4.072.217-7.404 7.03c-.292.277-.29.752.002 1.06.293.31.767.334 1.06.057l7.51-7.132.006 4.293c0 .414.336.768.75.79a.7.7 0 0 0 .748-.71l-.009-5.996a.8.8 0 0 0-.75-.79l-.1-.006h-.014z" />
  </svg>
);
ArrowTopRightIcon.id = 'ArrowTopRightIcon';
ArrowTopRightIcon.displayName = 'ArrowTopRightIcon';
export default ArrowTopRightIcon;
